import MuiButton, { ButtonOwnProps, ButtonProps } from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';

const sizeHeights: Record<NonNullable<ButtonProps['size']>, number> = {
  small: 36,
  medium: 40,
  large: 48,
};

export const Button = (({ size = 'medium', sx, ...props }: ButtonProps) => {
  return (
    <MuiButton
      size={size}
      sx={{ height: sizeHeights[size], ...sx }}
      {...props}
    />
  );
}) as typeof MuiButton;

export type { ButtonOwnProps, ButtonProps };
export { ButtonBase };
